module.exports = __webpack_public_path__ + "assets/images/stops.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/stops.png
// module id = 258
// module chunks = 1